import { cn } from '@/lib/utils'
import { Link, useLocation } from '@tanstack/react-router'
import { FolderIcon, HomeIcon, MenuIcon, ScanIcon } from 'lucide-react'
import { SidebarTrigger } from '../ui/sidebar'
import { UserNavMenu } from '../UserNavMenu'
import type { NavigationItem } from './LeftNavDashboard'

const navigationItems: NavigationItem[] = [
  {
    label: 'Home',
    href: '/home',
    icon: <HomeIcon size={16} />,
    enable: () => true,
  },
  {
    label: 'Documents',
    href: '/documents',
    icon: <FolderIcon size={16} />,
    enable: () => true,
  },
]

const TopNavMobile = () => {
  const { pathname } = useLocation()
  const isHome = pathname.includes('home')
  const pathLabel = pathname.includes('documents') ? 'Documents' : 'Home'

  return (
    <nav className="border-border bg-background fixed top-0 right-0 left-0 z-40 flex h-15 w-full items-center justify-between border-b px-4">
      {isHome ? (
        <img src="/assets/logo.svg" alt="LineWise Logo" className="h-5" />
      ) : (
        <SidebarTrigger icon={<MenuIcon className="size-5" />} />
      )}
      <span className="font-bold">{pathLabel}</span>
      <UserNavMenu />
    </nav>
  )
}

const TopNavDesktop = () => {
  const { pathname } = useLocation()

  return (
    <nav className="border-border bg-background h-100vh flex w-[115px] flex-col items-center justify-between border-r px-2 py-4">
      <div className="flex flex-col items-center gap-2">
        <img src="/assets/logo.svg" alt="LineWise Logo" className="h-8" />
        <div className="flex flex-col">
          {
            <Link
              to="/scan"
              className={cn(
                'text-copy-secondary flex h-15 w-[100px] items-center justify-center border-b-[3px] border-transparent',
                pathname.includes('scan') && 'bg-primary/10 rounded-md',
              )}
            >
              <div className="flex flex-col items-center gap-1">
                <span className="text-copy-secondary">
                  <ScanIcon size={16} />
                </span>
                <span
                  className={cn(
                    'text-sm',
                    pathname.includes('scan') && 'text-primary font-bold',
                  )}
                >
                  Scan
                </span>
              </div>
            </Link>
          }
          {navigationItems
            .filter((item) => item.enable())
            .map((item) => {
              const isActive = pathname.includes(item.href)
              return (
                <Link
                  key={item.label}
                  to={item.href}
                  className={cn(
                    'text-copy-secondary flex h-15 w-[100px] items-center justify-center border-b-[3px] border-transparent',
                    isActive && 'bg-primary/10 rounded-md',
                  )}
                >
                  <div className="flex flex-col items-center gap-1">
                    <span className="text-copy-secondary">{item.icon}</span>
                    <span
                      className={cn(
                        'text-sm',
                        isActive && 'text-primary font-bold',
                      )}
                    >
                      {item.label}
                    </span>
                  </div>
                </Link>
              )
            })}
        </div>
      </div>
      <UserNavMenu />
    </nav>
  )
}

export { TopNavMobile, TopNavDesktop }
